export const FORGOT_USERNAME_ATTEMPTS_LIMIT_ERROR_CODE = '42900';
export const INVALID_USER_NAME_ERROR_CODE = '40001';
